module.exports = __webpack_public_path__ + "img/f3.fc22b813.png";